<template>
  <div>
    <Button size="large" class="addbutton" @click="StarBirthdayManager">明星生日管理</Button>
    <Button size="large" class="addbutton" @click="getStarData">抓取明星数据</Button>
    <Button size="large" class="addbutton" @click="getCunData">抓取全国行政村数据</Button>
    <Button size="large" class="addbutton" @click="getRegionData">抓取全国行政区划数据</Button>
    <Button size="large" class="addbutton" @click="getAirportData">抓取中国民用机场数据</Button>
    <Progress :value="percent1" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshHistoryEvents">同步历史事件-极速数据</Button>
    <Progress :value="percent5" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RreshRollHistoricalEvent">获取历史事件-Roll</Button>
    <Progress :value="percent2" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshRecipeType">同步菜谱类型数据</Button>
    <Field label="菜谱类型ID" placeholder="请输入菜谱类型ID" v-model="input_id" style="display: none"></Field>
    <Field label="菜谱起始量" placeholder="请输入菜谱起始量" v-model="input_start" style="display: none"></Field>
    <Field label="菜谱数量" placeholder="请输入菜谱数量" v-model="input_num" style="display: none"></Field>
    <Progress :value="percent3" :bar-height="5" style="display: none"></Progress>
    <Button size="large" class="addbutton" @click="RefreshRecipe" style="display: none">同步菜谱数据</Button>
    <Progress :value="percent4" style="display: none" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" style="display: none" @click="RefreshContry">同步国家数据</Button>
    <Progress :value="percent6" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshTangShi">同步唐诗</Button>
    <Progress :value="percent7" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshSongCi">同步宋词</Button>
    <Progress :value="percent9" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshYuanQu">同步元曲</Button>
    <Progress :value="percent9" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshYueFu">同步乐府诗集</Button>
    <Progress :value="percent10" :bar-height="5"></Progress>
    <Button size="large" class="addbutton" @click="RefreshJoke">同步笑话</Button>
  </div>
</template>

<script>
import {Button, Progress, Field} from "mint-ui";

export default {
  name: "ManagerMain",
  components: {
    Button, Progress, Field
  },
  data() {
    return {
      input_id: null,
      input_start: null,
      input_num: null,
      token: localStorage.getItem('token'),
      freshHistoricalEventUrl: '/api/otherapi/freshHistoricalEvent',
      refreshRecipeTypeUrl: '/api/otherapi/refreshRecipeType',
      refreshRecipeUrl: '/api/otherapi/refreshRecipe',
      refreshContryUrl: '/api/otherapi/freshContry',
      freshRollHistoricalEventUrl: '/api/otherapi/getHistory',
      freshTangShiUrl: '/api/tangshi/freshTangShi',
      freshSongCiUrl: '/api/songci/freshSongCi',
      freshYuanQuUrl: '/api/yuanqu/freshYuanQu',
      freshYueFuUrl: '/api/yuefu/freshYueFu',
      freshJokeCiUrl: '/api/joke/freshJoke',
      getStarDataUrl: '/api/star/getStarData',
      getCunDataUrl: '/api/yigecun/getCunData',
      getAirportDataUrl: '/api/airport/getAirportData',
      getRegionDataUrl: '/api/mzb/getRegionData',
      getProgress1Url: '/api/otherapi/getRefreshHistoryEventsProgress',
      getProgress2Url: '/api/otherapi/getRefreshRecipeTypeProgress',
      getProgress3Url: '/api/otherapi/getRefreshRecipeProgress',
      getProgress4Url: '/api/otherapi/getRefreshContryProgress',
      getProgress5Url: '/api/otherapi/getHistoryProgress',
      getProgress6Url: '/api/tangshi/getProgress',
      getProgress7Url: '/api/songci/getProgress',
      getProgress8Url: '/api/joke/getProgress',
      getProgress9Url: '/api/yuanqu/getProgress',
      getProgress10Url: '/api/yuefu/getProgress',
      timer1: null,
      timer2: null,
      timer3: null,
      timer4: null,
      timer5: null,
      timer6: null,
      timer7: null,
      timer8: null,
      timer9: null,
      timer10: null,
      percent1: 0,
      percent2: 0,
      percent3: 0,
      percent4: 0,
      percent5: 0,
      percent6: 0,
      percent7: 0,
      percent8: 0,
      percent9: 0,
      percent10: 0,
    }
  },
  methods: {
    async getAirportData() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getAirportDataUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getCunData() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getCunDataUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getRegionData() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getRegionDataUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getStarData() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getStarDataUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    StarBirthdayManager() {
      this.$router.push('m_star_birthday_manager')
    },
    async RefreshJoke() {
      let that = this
      that.percent8 = 0
      that.timer8 = setInterval(() => {
        that.getPercent8()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshJokeCiUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshYueFu() {
      let that = this
      that.percent10 = 0
      that.timer10 = setInterval(() => {
        that.getPercent10()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshYueFuUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshYuanQu() {
      let that = this
      that.percent9 = 0
      that.timer9 = setInterval(() => {
        that.getPercent9()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshYuanQuUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshSongCi() {
      let that = this
      that.percent7 = 0
      that.timer7 = setInterval(() => {
        that.getPercent7()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshSongCiUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshTangShi() {
      let that = this
      that.percent6 = 0
      that.timer6 = setInterval(() => {
        that.getPercent6()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshTangShiUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RreshRollHistoricalEvent() {
      let that = this
      that.percent5 = 0
      that.timer5 = setInterval(() => {
        that.getPercent5()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.freshRollHistoricalEventUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshContry() {
      let that = this
      that.percent4 = 0
      that.timer4 = setInterval(() => {
        that.getPercent4()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.refreshContryUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshRecipe() {
      let that = this
      that.percent3 = 0
      that.timer3 = setInterval(() => {
        that.getPercent3()
      }, 3000)
      await that.$ajax({
        method: 'get',
        url: that.refreshRecipeUrl,
        params: {id: that.input_id, start: that.input_start, length: that.input_num},
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshRecipeType() {
      let that = this
      that.percent2 = 0
      that.timer2 = setInterval(() => {
        that.getPercent2()
      }, 1000)
      await that.$ajax({
        method: 'get',
        url: that.refreshRecipeTypeUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async RefreshHistoryEvents() {
      let that = this
      that.percent1 = 0
      that.timer1 = setInterval(() => {
        that.getPercent1()
      }, 3000)
      await that.$ajax({
        method: 'get',
        url: that.freshHistoricalEventUrl,
        headers: {token: that.token}
      }).then((response) => {
            that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })

    },
    async getPercent1() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress1Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent1 = parseFloat(response.data['responseData'])
            if (that.percent1 === 100) {
              clearInterval(that.timer1)
              that.$messagebox.alert("历史事件（极速数据）更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent2() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress2Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent2 = parseFloat(response.data['responseData'])
            if (that.percent2 === 100) {
              clearInterval(that.timer2)
              that.$messagebox.alert("菜谱类型更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent3() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress3Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent3 = parseFloat(response.data['responseData'])
            if (that.percent3 === 100) {
              clearInterval(that.timer3)
              that.$messagebox.alert("菜谱更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent4() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress4Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent4 = parseFloat(response.data['responseData'])
            if (that.percent4 === 100) {
              clearInterval(that.timer4)
              that.$messagebox.alert("菜谱国家数据完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent5() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress5Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent5 = parseFloat(response.data['responseData'])
            if (that.percent5 === 100) {
              clearInterval(that.timer5)
              that.$messagebox.alert("历史事件（Roll）更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent6() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress6Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent6 = parseFloat(response.data['responseData'])
            if (that.percent6 === 100) {
              clearInterval(that.timer6)
              that.$messagebox.alert("唐诗更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent7() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress7Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent7 = parseFloat(response.data['responseData'])
            if (that.percent7 === 100) {
              clearInterval(that.timer7)
              that.$messagebox.alert("宋词更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent8() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress8Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent8 = parseFloat(response.data['responseData'])
            if (that.percent8 === 100) {
              clearInterval(that.timer8)
              that.$messagebox.alert("笑话数据更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent9() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress9Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent9 = parseFloat(response.data['responseData'])
            if (that.percent9 === 100) {
              clearInterval(that.timer9)
              that.$messagebox.alert("元曲数据更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    async getPercent10() {
      let that = this
      await that.$ajax({
        method: 'get',
        url: that.getProgress10Url,
        headers: {token: that.token}
      }).then((response) => {
            that.percent10 = parseFloat(response.data['responseData'])
            if (that.percent10 === 100) {
              clearInterval(that.timer10)
              that.$messagebox.alert("乐府诗集数据更新完成", '信息提示')
            }
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.addbutton {
  background: lightseagreen;
  margin-bottom: 0.5rem;
}
</style>
